// client/src/utils/apiBase.js
// Central API base for all Cloud Functions calls.
// Set REACT_APP_FUNCTIONS_BASE_URL in client/.env.development / .env.production
// to point at the matching Firebase project. Falls back to production so
// existing prod builds behave identically.
export const API_BASE =
  process.env.REACT_APP_FUNCTIONS_BASE_URL ||
  "https://us-central1-lottologic-e2dee.cloudfunctions.net";

export function apiUrl(name) {
  return `${API_BASE}/${name}`;
}
